import React from 'react';
import { browserHistory } from 'react-router';

import FbShareBtn from '../FbShareBtn';

import CharacterProfileImage from '@evdy/web-core/dist/components/shared/elements/CharacterProfileImage';
import { formatTime } from '@evdy/web-core/dist/lib/utils';

import styles from './DecedentInfo.module.scss';

const {
  'decedent-info': decedentInfoClass,
  'hero-background': heroBackgroundClass,
  'decedent-content': decedentContentClass,
  details: detailsClass,
  'decedent-image': decedentImageClass,
  'decedent-copy': decedentCopyClass,
  'fb-share': fbShareClass,
  'hero-ctas': heroCTAsClass,
  'post-message-btn': postMessageBtnClass,
  'share-btn': shareBtnClass,
  //<CharacterProfileImg /> custom styles for community
  'char-profile-img-wrapper': decedentCharImgWrapperClass,
  'char-profile-img': charProfileImgClass,
  'char-profile-no-img': charProfileNoImgClass,
  'char-profile-font': charProfileFontClass
} = styles;

const DecedentInfo = ({
  displayName,
  image,
  dateOfBirth,
  dateOfDeath,
  shareUrl = '',
  openShareModal,
  baseRoute,
  name
}) => {
  const formattedDateOfBirth = formatTime(dateOfBirth, 'YYYY');
  const formattedDateOfDeath = formatTime(dateOfDeath, 'YYYY');
  const missingDodAndDob = !dateOfBirth && !dateOfDeath;
  //format strings
  const formattedDates = missingDodAndDob
    ? '' //No Dates Provided
    : !dateOfDeath
    ? `Born ${formattedDateOfBirth}` //No Birth Date Provided
    : !dateOfBirth
    ? `Passed ${formattedDateOfDeath}` //No Death Date Provided
    : `${formattedDateOfBirth} - ${formattedDateOfDeath}`; //Both Dates Provided

  return (
    <div className={decedentInfoClass}>
      <div className={heroBackgroundClass} />
      <div className={decedentContentClass}>
        <div className={decedentImageClass}>
          <CharacterProfileImage
            customClasses={[decedentCharImgWrapperClass]}
            customProfileImgClasses={[charProfileImgClass]}
            customClassNoImg={[charProfileNoImgClass]}
            customClassFont={[charProfileFontClass]}
            {...{ image, name }}
          />
        </div>
        <div className={detailsClass}>
          <h5>In Loving Memory Of</h5>
          <h1>{displayName}</h1>
          <div className={decedentCopyClass}>
            <span>{formattedDates}</span>
            <FbShareBtn {...{ fbShareClass, shareUrl }} />
          </div>
        </div>
      </div>
      <div className={heroCTAsClass}>
        <button
          onClick={() => browserHistory.push({ pathname: `${baseRoute}/condolence/create` })}
          className={postMessageBtnClass}
        >
          Post message
        </button>
        <button onClick={openShareModal} className={shareBtnClass}>
          Share
        </button>
      </div>
    </div>
  );
};

export default DecedentInfo;
